<template>
  <edit-text-field :filled="filled" :label="uLabel" :value="value" :suffix="unit" @input="update" v-if="type == 'currency'" format="currency" required="isRequired"></edit-text-field>
  <edit-text-field :filled="filled" :label="uLabel" :value="value" :suffix="unit" @input="update" v-else-if="type == 'number'" format="decimal" required="isRequired"></edit-text-field>
  <edit-text-field :filled="filled" :label="uLabel" :value="value" :suffix="unit" @input="update" v-else-if="type == 'decimal'" format="decimal" required="isRequired"></edit-text-field>
  <edit-text-field :filled="filled" :label="uLabel" :value="value" :suffix="unit" @input="update" v-else-if="type == 'int'" format="int" required="isRequired"></edit-text-field>
</template>

<script>
import EditTextField from "../utils/EditTextField";

export default {
  name: "InquiryFieldNumber",

  components: {
    EditTextField
  },

  props: {
    value: [String, Number],
    unit: String,
    label: String,
    type: String,
    fieldId: String,
    filled: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      "requiredFields": ["price.value", "area.livingSpace"]
    }
  },

  computed: {
    uLabel() {
      if (this.isRequired) {
        return this.label + "*";
      }

      return this.label;
    },

    isRequired() {
      if (this.requiredFields.find(x => x == this.fieldId)) {
        return true;
      }

      return false;
    },

    suffix() {
      return this.unit;
    }
  },

  methods: {
    update(value) {
      this.$emit("update", value);
    }
  }
};
</script>
